import { withStyles } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';

import { expansionPanelStyles } from './expansion-panel.styles';

export const ExpansionPanel = withStyles(expansionPanelStyles)(MuiAccordion);
